export default __webpack_public_path__ + "static/media/explore-iv-banner-3.0ff3d123.png";